// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preferences_body__1ktlZ {\n  min-width: 800px;\n  min-height: 450px;\n  align-items: unset;\n}\n.preferences_body__1ktlZ footer {\n  display: flex;\n  margin: 1rem;\n  align-items: center;\n  justify-content: center;\n}\n.preferences_body__1ktlZ .preferences_title__1z3DM {\n  padding: 0;\n  align-items: stretch;\n}\n\n.preferences_tab__1P5Xt {\n  flex: 1;\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.preferences_label__3xOt8 {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  text-transform: uppercase;\n}", ""]);
// Exports
exports.locals = {
	"body": "preferences_body__1ktlZ",
	"title": "preferences_title__1z3DM",
	"tab": "preferences_tab__1P5Xt",
	"label": "preferences_label__3xOt8"
};
module.exports = exports;
